import React, { useState } from "react";
import BusinessInformation from "@/pages/campaignCreate/components/businessInformation";
import { CreateCampaignStageEnum } from "@/pages/campaignCreate/config";
import { Table } from "antd";
import TableCreatorName from "@/components/TableCreatorName";
import { dataLists } from "./config";
interface Props {
}

const testCampaignDetails: React.FC<Props> = ({}) => {
  const url = new URL(window.location.href);
  const params = url.searchParams;
  const valueIndex = params.get('valueIndex');
  const numValueIndex = valueIndex !== null && !isNaN(Number(valueIndex)) ? Number(valueIndex) : 0;
  const detailsData = dataLists[numValueIndex];

  const columns = [
    {
      title: "Name",
      dataIndex: "creatorName",
      width: 260,
      render: (_: string, item: any) => {
        return <TableCreatorName item={item} />;
      },
    },
    {
      title: "Followers",
      dataIndex: "followers",
      width: 140,
      align: 'left' as const,
      render: (text: string, item: any) => (
        <div className="">{text}</div>
      ),
    },
    {
      title: "Est. views/post",
      dataIndex: "viewsPost",
      width: 140,
      align: 'left' as const,
        render: (text: string) => (
          <div className="">{text}</div>
      ),
    },
    {
      title: "Core audience",
      dataIndex: "coreAudience",
      align: 'left' as const,
      render: (text: string) => (
        <div className="truncate max-w-[660px]">{text}</div>
      ),
    }
  ];

  return (
    <div className="mt-6 mx-[120px]"> 
      <BusinessInformation
        ref={null}
        setNextLoading={() => {}}
        stage={CreateCampaignStageEnum.BUSINESS_INFORMATION}
        details={detailsData}
        setNextDisabled={() => {}}
        isNextLoading={false}
      />
      <div className="form-card w-full">
        <div className="text-[20px] font-semibold mb-2">
          Sample influencers you may collaborate with
        </div>
        <div className="mb-4">
          Based on the campaign information you provided, we've pre-matched these sample influencers to help you assess audience fit. If they're not ideal, feel free to adjust your campaign inputs.
        </div>
        <div className="w-full">
          <Table
            rowKey="userName"
            columns={columns}
            dataSource={detailsData?.product?.tableLists}
            pagination={false}
          />
        </div>
        
      </div>
    </div>
  );
};

export default testCampaignDetails;